<template>
  <div class="surveillance-symptoms">
    <div slot="header" class="clearfix">
        <el-col :span="5"><span>Infection Site/Type: </span></el-col>
        <el-col :span="14">{{caseData.symptomType}} - 
          <el-tooltip class="item" effect="dark" :content="symptomDetail(caseData.symptomType)" placement="bottom">
            <a href="#">View Details</a>
          </el-tooltip>
        </el-col>
    </div>
    <div class="clearfix"></div>    
    <!--<h1>{{ caseData }}</h1>-->
    <el-row>
        <el-col :span="5"><span>Symptoms Exhibited: </span></el-col>
        <el-col :span="16">
                <el-table
                border
                :data="caseData.symptoms"
                style="width: 100%"
                :default-sort = "{prop: 'created', order: 'descending'}"
                >
                  <el-table-column
                    label="On Set Date"
                    width="120">
                    <template scope="scope">
                      {{ scope.row.onSetDate | moment('DD-MM-YYYY') }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="Symptom">
                    <template scope="scope">
                      <div class="case-note-content">{{ scope.row.displayText }}</div>
                    </template>
                  </el-table-column>
                </el-table>
        </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  name: 'surveillance-symptoms',
  props: ['caseData'],
  data: function () {
    return {
      biologyInfo: [
        {
          label: 'Primary'
        },
        {
          label: 'Secondary'
        },
        {
          label: 'Primary'
        },
        {
          label: 'Quaternary'
        }
      ]
    }
  },
  methods: {
    symptomDetail (symptomType) {
      return symptomType + ' detail text goes here'
    }
  }
}
</script>
<style scoped>
div {
    line-height: 3em;
}

.clearfix:before,
  .clearfix:after {
      display: table;
      content: "";
  }

.clearfix {
    clear: both;
    margin-bottom: 1em;
}
</style>


// WEBPACK FOOTER //
// SurveillanceSymptoms.vue?8882e9ba